import React from "react";
import Auth from "../../components/Auth/Auth";
import check from "../../assets/images/check.png";
import { useLocation, useNavigate } from "react-router-dom";
import { emailSent } from "../../features/slices/authReducer";
import { useDispatch } from "react-redux";
const SendEmail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const handleSubmit = () => {
    navigate("/resetPassword", { state: { email: state?.email } });
  };
  const reSubmit = () => {
    dispatch(emailSent({ email: state?.email }));
  };
  return (
    <Auth className="LoginLeft text-center">
      <figure>
        <img src={check} />
      </figure>
      <h2>Success</h2>
      <h6>
        Please check your email for create <br />a new password{" "}
        <strong>{state?.email}</strong>
      </h6>
      <form>
        {/* <a className="Button" onClick={handleSubmit}>
          Create New Password
        </a> */}
        <div className="Checkboxs">
          <p className="BackToLogin">
            Can't get email?
            <a onClick={reSubmit}>
              {" "}
              <strong>Resubmit</strong>
            </a>
          </p>
        </div>
      </form>
    </Auth>
  );
};

export default SendEmail;
